Format = require 'lib/markdown/format'
PluginIO = require 'views/internal/plugins/plugin-io'
Promise = require 'bluebird'
React = require 'react'
PropTypes = require 'prop-types'
t = require('views/internal/recup-with-helpers')()

template = t.renderable ({ descriptionHtml } = {}) ->
  t.div '.markeddown', ->
    t.raw descriptionHtml

module.exports = class extends React.Component
  displayName: 'PluginGearComponent'
  keepInDOM: true

  propTypes:
    io: PropTypes.instanceOf(PluginIO)
    model: PropTypes.object

  constructor: (props) ->
    super(props)

    @state = {
      details: ""
    }

  componentDidMount: ->
    Promise.props
      description: @props.io.getDescription()
    .then (data) =>
      @setState(data)

    return

  render: ->
    template({ descriptionHtml: Format.markdownAsHtml(@state.description) })



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-details-view.coffee